import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetColectionCount } from 'src/queries';
import { useOrganizationState } from 'src/state';

import { homeMenuIcon } from '../../../../assets';
import { MenuIcon } from '../../../../components';
import { MenuGrid } from '../../Home.styled';

interface HomeMenuProps {
  showPartnerProgramInfo: () => void;
  showWifiInfo: () => void;
  showVirtualTour: () => void;
  showSocialMedia: () => void;
  showOpinions: () => void;
}

export const HomeMenu: FC<HomeMenuProps> = (props) => {
  const { t } = useTranslation();
  const { organizationData } = useOrganizationState();
  const { data: eventsCount } = useGetColectionCount(`hotels/${organizationData.id}/events`);
  const { data: goodPracticesCount } = useGetColectionCount(`hotels/${organizationData.id}/goodPractise`);
  const { data: specialOffersCount } = useGetColectionCount(`hotels/${organizationData.id}/specialOffer`);
  const { data: rentalsCount } = useGetColectionCount(`hotels/${organizationData.id}/rentals`);
  const { data: regulationsCount } = useGetColectionCount(`hotels/${organizationData.id}/regulations`);
  const { data: conferencesCount } = useGetColectionCount(`hotels/${organizationData.id}/conferences`);
  const {
    showPartnerProgramInfo,
    showWifiInfo,
    showVirtualTour,
    showSocialMedia,
    showOpinions,
  } = props;
  const navigate = useNavigate();
  interface HomeMenuItem {
    id: string;
    label: string;
    icon: string;
    action: () => void;
  }

  const handelClick = (path: string) => () => {
    navigate(path);
  };

  const homeMenu = [
    eventsCount && eventsCount > 0 && {
      id: 'hotel-events',
      label: t('menu_items.hotel_events'),
      icon: homeMenuIcon.hotelEvent,
      action: handelClick('events'),
    },
    goodPracticesCount && goodPracticesCount > 0 && {
      id: 'good-practices',
      label: t('menu_items.good_practice'),
      icon: homeMenuIcon.goodPractice,
      action: handelClick('good-practices'),
    },
    organizationData?.loyalty_program_url && {
      id: 'loyalty',
      label: t('menu_items.loyalty'),
      icon: homeMenuIcon.qrCode,
      action: showPartnerProgramInfo,
    },
    {
      id: 'hotel-info',
      label: t('menu_items.hotel_info'),
      icon: homeMenuIcon.info,
      action: handelClick('about-hotel'),
    },
    specialOffersCount && specialOffersCount > 0 && {
      id: 'special-offers',
      label: t('menu_items.special_offer'),
      icon: homeMenuIcon.specialOffers,
      action: handelClick('special-offers'),
    },
    organizationData?.opinionServicesSettings && {
      id: 'opinion',
      label: t('menu_items.opinion'),
      icon: homeMenuIcon.opinion,
      action: showOpinions,
    },
    organizationData?.wifiSettings?.ssid && {
      id: 'wifi',
      label: t('menu_items.wifi'),
      icon: homeMenuIcon.wifi,
      action: showWifiInfo,
    },
    rentalsCount && rentalsCount > 0 && {
      id: 'rentals',
      label: t('menu_items.rent'),
      icon: homeMenuIcon.rentals,
      action: handelClick('rentals'),
    },
    conferencesCount && conferencesCount > 0 && {
      id: 'conferences',
      label: t('conferences_screen.title'),
      icon: homeMenuIcon.hotelEvent,
      action: handelClick('conferences'),
    },
    organizationData?.virtual_tour_url && {
      id: 'virtual_tour',
      label: t('menu_items.virtual_tour'),
      icon: homeMenuIcon.virtualTour,
      action: showVirtualTour,
    },
    organizationData?.socialMediaSettings && {
      id: 'social_media',
      label: t('menu_items.social_media'),
      icon: homeMenuIcon.socialMedia,
      action: showSocialMedia,
    },
    regulationsCount && regulationsCount > 0 && {
      id: 'regulations',
      label: t('menu_items.regulations'),
      icon: homeMenuIcon.regulations,
      action: handelClick('regulations'),
    },
    {
      id: 'channels',
      label: t('channels_screen.title'),
      icon: homeMenuIcon.info,
      action: handelClick('channels'),
    },
  ].filter(Boolean) as HomeMenuItem[];

  return (
    <MenuGrid>
      {homeMenu.map((item) => (
        <MenuIcon
          key={item.id}
          icon={item.icon}
          title={item.label}
          onClick={item.action}
        />
      ))}
    </MenuGrid>
  );
};
